import { mockDataProjects } from "../../data/mockProjectData";
import { ADD_PROJECT } from "../actions";


const initialState = mockDataProjects;


const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    // handle actions here if needed
    case ADD_PROJECT:
        return [...state, action.payload];
    default:
      return state;
  }
};


export default projectReducer;
